'use client';

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// --- Query Keys ---

export const queryKeys = {
  videos: (params?: Record<string, string>) => ['videos', params] as const,
  video: (id: string) => ['video', id] as const,
  recordings: () => ['recordings'] as const,

  favoriteSentences: () => ['favoriteSentences'] as const,
  favoriteWords: () => ['favoriteWords'] as const,
  globalFavoriteWords: () => ['globalFavoriteWords'] as const,
  notes: () => ['notes'] as const,

  stats: () => ['userStats'] as const,
  profile: () => ['profile'] as const,

  progressRecent: () => ['progressRecent'] as const,
  videoProgress: (videoId: string) => ['videoProgress', videoId] as const,
} as const;
